export default __webpack_public_path__ + "static/media/circle.e259f2f7.svg";